import {Button, Card, CardContent, CardMedia, Fade, Typography} from "@mui/material";
import React, {useRef} from "react";
import LogoImage from '../assets/logomain.webp';
import ImageTwo from "../assets/2.jpg";
import ImageTwoLight from "../assets/2-light.jpg";
import ImageThree from "../assets/3.jpg";
import ImageThreeLight from "../assets/3-light.jpg";
import "./FeatureCard.css";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import {MobileTooltip} from "./Tooltip";

export default function FeatureCard({noUser, darkMode, handleToggle, children, topRef}) {
    const [mainImageLoaded, setMainImageLoaded] = React.useState(false);
    const ref = useRef(null);
    return (
        <>

            <Card className={"FeatureCard"}
                  sx={{margin: 'auto', maxWidth: 375, paddingTop: '1em', marginBottom: "64px", zIndex: 3}}>
                <Fade in={mainImageLoaded}>
                    <CardMedia sx={{objectFit: 'contain', height: "230px"}}
                               className={"logo"}
                               component="img"
                               image={LogoImage}
                               onLoad={(() => {
                                   setMainImageLoaded(true)
                               })}
                    />
                </Fade>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        <span
                            style={{fontFamily: "'IBM Plex Sans', 'Roboto'", letterSpacing: "-0.5px"}}>sidebae/what you want</span>
                    </Typography>
                    <Typography variant="body1">
                        The collectors side thing
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        A global eBay search built for collectors: sidebae allows collectors to expand their eBay daily hunt globally while saving time with an optimized interface and daily email alerts.
                    </Typography>
                    <br/>
                    <div style={{display: "flex", gap: 4, flexWrap: "wrap"}}>
                        <Button sx={{width: "73.29px"}} onClick={() => {
                            handleToggle(0, null, true);
                        }}>{noUser ? "Sign in" : "Profile"}</Button>
                        {/*<Button onClick={() => {*/}
                        {/*    topRef?.current?.scrollIntoView({behavior: "smooth", block: "center"});*/}
                        {/*}}>Top Listings</Button>*/}
                        <Button onClick={() => {
                            ref.current?.scrollIntoView({behavior: "smooth", block: "center"});
                        }}>Learn more</Button>
                    </div>
                </CardContent>
            </Card>
            {children}
            <div className={"LearnMore"} style={{
                maxWidth: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap"
            }}>
                <Card ref={ref} sx={{margin: '2em', maxWidth: 375}}>
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            Wait, why <span
                            style={{fontFamily: "'IBM Plex Sans', 'Roboto'", letterSpacing: "-0.5px"}}>sidebae</span>?
                        </Typography>
                        <Typography variant="body1">
                            eBay is hiding listings from you
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            No, not under their bed. Listings that do not have a shipping option to your country are
                            hidden when searching from your local eBay.<br/><br/>
                            sidebae ensures that you see every listing by combining listings from each eBay locale (12
                            of them!).
                        </Typography>
                    </CardContent>
                </Card>
                <Card sx={{margin: '2em', maxWidth: 375}}>
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            Where do I start?
                        </Typography>
                        <Typography variant="body1">
                            Tap the search bar to query a global search
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            BYOS (Bring Your Own Search) is probably the best way to use sidebae. <br/><br/>
                            Advanced settings like preferred currency or price range can be set by tapping the more
                            arrow.
                        </Typography>
                    </CardContent>
                </Card>
                <Card sx={{margin: '2em', maxWidth: 375}}>
                    <CardMedia sx={{objectFit: 'contain'}}
                               component="img"
                               width={'100%'}
                               image={darkMode ? ImageTwo : ImageTwoLight}
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            What do I get with an account?
                        </Typography>
                        <Typography variant="body1">
                            Star a favorite search to set it as default and click the bell to subscribe
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Searches can be saved and starred to query when you enter the
                            site.<br/><br/> Searches can also be subscribed to and are updated every 15 minutes.
                        </Typography>
                    </CardContent>
                </Card>
                <Card sx={{margin: '2em', maxWidth: 375}}>
                    <CardMedia sx={{objectFit: 'contain'}}
                               component="img"
                               width={'100%'}
                               image={darkMode ? ImageThree : ImageThreeLight}
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            What else can I do with an account?
                        </Typography>
                        <Typography variant="body1">
                            Tap the country or the seller tag in the listing preview to block them
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Sellers and countries can be blocked from appearing in your
                            searches. Blocked sellers and countries can be managed in the profile panel. <br/><br/>
                            More advanced features such as Quick Scroll and Auto Refresh can be set by tapping the
                            settings icon in the profile panel.
                        </Typography>
                    </CardContent>
                </Card>
                <div className={"MarginBottom"}
                     style={{marginBottom: "2em", width: "100%", display: "flex", justifyContent: "center"}}>
                    <MobileTooltip enterDelay={500} title={"To top"} placement={"right"}>
                        <Button sx={{margin: "auto"}} onClick={() => {
                            window.scrollTo({top: 0, behavior: "smooth"})
                        }}><ArrowCircleUpIcon fontSize={"large"}/></Button>
                    </MobileTooltip>
                </div>
            </div>
        </>
    );
}